import { Button, Icon, FileDrop, Progress } from '@scuf/common';
import React, { FunctionComponent, useState } from 'react';
import { IUserActionRequestModel } from '../../models/IOpportunitiesAPIModel';
import { useAppDispatch } from '../../store';
import { toast, Zoom } from 'react-toastify';
import { Snackbar } from '../../components/Snackbar/Snackbar';
import { saveUserActionData } from '../../services/UserAction';
import './FileUpload.scss';
import { nanoid } from '@reduxjs/toolkit';
import { getMessage } from 'src/message/utils';

interface IUploadFileModalProps {
  // onClose: Function;
  // open?: boolean;
  anomaly_id: any;
  opportunityId: any;
  className: string;
  type: string;
  updateUploadedStatus?: (val: boolean) => void;
  onUploadSuccess?: () => void;
  // addedcomment?: boolean;
  // acceptedFlag?: boolean;
  // rejecetedFlag?: boolean;
}

interface NewFile {
  name?: string | undefined;
  id?: string;
  uploaded?: boolean;
}

export const FileUpload: FunctionComponent<IUploadFileModalProps> = (props) => {
  const [acceptedFiles, setAcceptedFiles] = useState<File>();
  const [acceptedFilesArray, setAcceptedFilesArray] = useState<File[]>([]);

  const [loadingText, setLoadingText] = useState('Upload');
  const [isloading, setIsLoading] = useState(false);
  const [enableRetryErr, setEnableRetryErr] = useState(false);
  const [, setDisableSubmit] = useState(true);
  const dispatch = useAppDispatch();
  const [, setFileName] = useState('');
  const [, setShowUpload] = useState(true);
  const [isRejected, setIsRejected] = useState<boolean>(false);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [rejectedFiles, setRejectedFiles] = useState<File[]>([]);
  const dragDroptext = getMessage('app.anomalydetails.comment.dragdrop');
  const inProgressText = getMessage('app.anomalydetails.fileupload.inprogress');
  const successText = getMessage('app.anomalydetails.fileupload.success');
  const errorText = getMessage('app.anomalydetails.fileupload.error');

  type ToastType = 'loading' | 'failure' | 'success' | 'valid_file';


  const showActionToast = (type: ToastType) => {
    if (type === 'loading') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-info"
            root="common"
            size="large"
            color="#007ad9"
            className="status-indicator-icon"
          />{' '}
          {inProgressText}{' '}
        </div>
      );
      // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'success') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-check"
            root="common"
            size="large"
            color="#279d2b"
            className="status-indicator-icon"
          />{' '}
          {successText}{' '}
        </div>
      );
      // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'failure') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-stop"
            root="common"
            size="large"
            color="#BE271C"
            className="status-indicator-icon"
          />
          {errorText}{' '}
        </div>
      );
      // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
    else if (type === 'valid_file') {
      const toastContent = (
        <div className="export-snackbar-content">
          <Icon
            name="badge-stop"
            root="common"
            size="large"
            color="#BE271C"
            className="status-indicator-icon"
          />
          {'The file is corrupted. Upload a valid file'}
        </div>
      );
      // @ts-ignore
      toast(<Snackbar toastMessage={toastContent} />, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };


  const handleUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setAcceptedFiles(event.target.files[0]);
      let acceptedFilesArrayValue = acceptedFilesArray;
      acceptedFilesArrayValue.push(event.target.files[0]);
      setAcceptedFilesArray(acceptedFilesArrayValue);
      setFileName('');
    }
  };

  const removeSelcetedFile = (id: string) => {
    setUploadedFiles(uploadedFiles.filter((file: NewFile) => file.id !== id));
    // @ts-ignore
    props.updateUploadedStatus(false);
  };

  const endProgressSimulation = (uploadingFiles: File[]) => {
    setTimeout(() => {
      setUploadedFiles((allFiles: File[]) => {
        const updatedFiles = allFiles.map((file: NewFile) => {
          if (
            uploadingFiles
              .map((loadingFile) => loadingFile.name)
              .includes(file.name as string)
          ) {
            file.uploaded = true;
            return file;
          } else {
            return file;
          }
        });
        return updatedFiles as File[];
      });
    }, 2000);
  };

  const dropAccepted = (files: File[]) => {
    if (files && files[0]) {
      setAcceptedFiles(files[0]);
      // @ts-ignore
      props.updateUploadedStatus(true);
    }
    setUploadedFiles(
      (allFiles: File[]) => {
        const newFiles = files.map((file: NewFile) => {
          const fileInProgress = Object.assign(file, {
            uploaded: false,
            id: nanoid(),
          });
          return fileInProgress;
        });
        return [...allFiles, ...newFiles];
      },
      // @ts-ignore
      endProgressSimulation(files)
    );
  };

  const dropRejected = (files: File[]) => {
    setRejectedFiles((allFiles: File[]) => {
      return [...allFiles, ...files];
    });
    setIsRejected(true);
  };

  const onSubmitClick = () => {
    setDisableSubmit(false);
    showActionToast('loading');
    setIsLoading(true);
    setEnableRetryErr(false);
    setLoadingText('Uploading...');
    let formDataValue = {} as IUserActionRequestModel;
    formDataValue.supportFile = acceptedFiles;
    let formData = new FormData();
    // formData.append('type',props.type)
    if (acceptedFiles) {
      // for (let i = 0; i < uploadedFiles.length; i++) {
      // @ts-ignore
      formData.append(`supportFile`, acceptedFiles);
      // }
    }

    const config = {
      // headers: {
        'Content-Type': 'multipart/form-data',
      // },
    };
    dispatch(
      // @ts-ignore
      saveUserActionData(props.opportunityId, formData, props.type, config)
    )
      // @ts-ignore
      .then((res) => {
        if(res.data === 'Upload a valid file'){
          showActionToast('valid_file');
          setIsLoading(false);
          setLoadingText('Upload');
          setShowUpload(false)
          setUploadedFiles([]); 
          // @ts-ignore
          props.updateUploadedStatus(false);
        }
        else{
          setIsLoading(false);
          setLoadingText('Upload');
          showActionToast('success');
          setShowUpload(false);
          setUploadedFiles([]);        
          // @ts-ignore
          props.updateUploadedStatus(false);
          props.onUploadSuccess?.();
          // props.onClose();
        }
      })
      .catch((err: any) => {        
        showActionToast('failure');
        setIsLoading(false);
        setLoadingText('Retry');
        setEnableRetryErr(true);
        console.log(' error ', err);        
      });
  };

  return (
    <div className="file_upload-wrapper">
      {
        <div>
          {/* <div className="file_upload-wrapper__input"> */}
          {/* <span>Drag and drop here</span>&nbsp;
        <span>or</span>&nbsp; */}
          {/* <input
            type="file"
            id="input"
            className="file_upload-wrapper__input--text"
            multiple
            onChange={handleUpload}
            accept=".jpeg, .pdf,.jpg ,.docx,.xlsx,.png"
          ></input> */}

          {/* <Accordion>
            <Accordion.Content
              title="Upload File"
              active={isActive}
              onClick={handleActive}
              className={"right-rail__file-upload"}
            > */}
          <FileDrop
            acceptedTypes=".jpeg, .pdf,.jpg ,.docx,.xlsx,.png,.msg,.nst"
            multiple={false}
            buttonText={dragDroptext}
            maxSize={20000000} // (20MB)
            placeholder="Drop or Upload File(.png | .jpg | .jpeg | .docx | .pdf |.xlsx|.msg|.nst)"
            onChange={handleUpload}
            className="right-rail"
            onAccepted={(files) => {
              dropAccepted(files);
            }}
            onRejected={(files) => dropRejected([...rejectedFiles, ...files])}
            onReset={() => {
              setUploadedFiles([]);
              setIsRejected(false);
              setLoadingText('Upload');
              setEnableRetryErr(false);
              // @ts-ignore
              props.updateUploadedStatus(false);
            }}
            error={
              isRejected
                ? '[Only files less than 20 MB are allowed] Please retry with a valid file.'
                : ''
            }
            disabled={uploadedFiles.length > 0 ? true : false}
          />
          <div className="file-size-note">[Only files less than 20 MB are allowed]</div>
          {uploadedFiles &&
            uploadedFiles.map((file: NewFile) => (
              <>
                <div key={file.id} className="acceptedFiles-container">
                  <div className="fileName-container">
                    {file.uploaded ? (
                      <Icon name="check" color="green" />
                    ) : (
                      <Progress circular={true} size="xsmall" />
                    )}
                    <p className="truncate-text">{file.name}</p>
                    <span onClick={() => removeSelcetedFile(file.id as string)}>
                      <Icon name="close" size="small" />
                    </span>
                  </div>
                  <Button
                    data-testid="save"
                    icon={
                      enableRetryErr ? (
                        <Icon root="building" name="refresh" exactSize={30} />
                      ) : (
                        ''
                      )
                    }
                    className={`button--secondary right-rail-button upload-file_button--wrapper__upload ${
                      isloading ? 'btn-loading' : ''
                    }`}
                    size="small"
                    iconPosition="right"
                    type="secondary"
                    onClick={() => onSubmitClick()}
                  >
                    {loadingText}
                  </Button>
                </div>
              </>
            ))}
          {/* </Accordion.Content>
          </Accordion> */}
        </div>
      }

      {/* <div className="file_upload-wrapper__button--wrapper">
        <Button type='secondary' size='medium' data-testid='cancel' content='Cancel' className='button--secondary upload-file_button--wrapper__cancel' onClick={() => props.onClose()} />
        <Button
          data-testid="save"
          icon={
            enableRetryErr ? (
              <Icon root="building" name="refresh" exactSize={30} />
            ) : (
              ''
            )
          }
          className={`button--secondary upload-file_button--wrapper__upload ${
            isloading ? 'btn-loading' : ''
          }`}
          size="small"
          style={{display: }}
          iconPosition="right"
          type="secondary"
          onClick={() => onSubmitClick()}
        >
          {loadingText}
        </Button>
      </div> */}
    </div>
  );
};
